import { RegisterOptions, Validate } from 'react-hook-form'

export const REQUIRED_MESSAGE = gettext('This field is required.')
export const requiredRule: RegisterOptions = { required: REQUIRED_MESSAGE }
export const listNotEmpty: Validate = (value: string[]) => value.length > 0 || REQUIRED_MESSAGE

interface ValueLengthValidatorArgs {
  value: string
  minLengthRequired?: number
  maxLengthRequired?: number
}

export const valueLengthValidator = ({
  value,
  minLengthRequired,
  maxLengthRequired,
}: ValueLengthValidatorArgs): string | true => {
  if (minLengthRequired && value && value.length < minLengthRequired) {
    return interpolate(
      ngettext(
        'Ensure this value has at least %(minLengthRequired)s character (it has %(valueLength)s).',
        'Ensure this value has at least %(minLengthRequired)s characters (it has %(valueLength)s).',
        minLengthRequired
      ),
      { minLengthRequired: minLengthRequired.toString(), valueLength: value.length.toString() },
      true
    )
  }

  if (maxLengthRequired && value && value.length > maxLengthRequired) {
    return interpolate(
      ngettext(
        'Ensure this value has at most %(maxLengthRequired)s character (it has %(valueLength)s).',
        'Ensure this value has at most %(maxLengthRequired)s characters (it has %(valueLength)s).',
        maxLengthRequired
      ),
      { maxLengthRequired: maxLengthRequired.toString(), valueLength: value.length.toString() },
      true
    )
  }

  return true
}
